/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listingbuttonsdescription2Inputs */

const en_listingbuttonsdescription2 = /** @type {(inputs: Listingbuttonsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What guests can do on your place's page with one tap: one to four buttons, the first one stands out.`)
};

const de_listingbuttonsdescription2 = /** @type {(inputs: Listingbuttonsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was Gäste auf der Seite deines Orts mit einem Tipp tun können: ein bis vier Knöpfe, der erste ist hervorgehoben.`)
};

/**
* | output |
* | --- |
* | "What guests can do on your place's page with one tap: one to four buttons, the first one stands out." |
*
* @param {Listingbuttonsdescription2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const listingbuttonsdescription2 = /** @type {((inputs?: Listingbuttonsdescription2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listingbuttonsdescription2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listingbuttonsdescription2(inputs)
	return de_listingbuttonsdescription2(inputs)
});
export { listingbuttonsdescription2 as "listingButtonsDescription" }